<app-page
  title="Manage Account"
  [isLoading]="(authenticatedUser$ | async) === null || (authenticatedUser$ | async) === undefined"
>
  <div class="mb-5">
    <div class="my-0 p2 font-semibold" data-cy="account-email-label">Email Address:</div>
    <div class="my-0 p2 font-light" data-cy="account-email-value">
      {{ (authenticatedUser$ | async)?.email || '' }}
    </div>
  </div>
  <p-card styleClass="card-min-h" data-cy="update-password-form-container">
    <div class="flex align-items-center justify-content-between flex-wrap">
      <h2 class="my-1">Change Password</h2>
      <button
        pButton
        type="button"
        label="Forgot Password?"
        class="p-button-text p-button-sm mt-2 sm:mt-0 cursor-pointer"
        pTooltip="If you forgot your current password, please sign out then click Forgot Password."
        tooltipPosition="top"
        tooltipEvent="focus"
        data-cy="forgot-password-tooltip"
        appClickEvent
        eventName="user_account_forgot_password_tooltip"
      ></button>
    </div>
    <p-divider></p-divider>
    <div class="form-container">
      <div *ngIf="errorMessage" class="col-12">
        <app-message severity="error" [noMargin]="true" data-cy="update-password-error-message">
          {{ errorMessage }}
        </app-message>
      </div>
      <div *ngIf="successMessage" class="col-12">
        <app-message severity="success" [noMargin]="true" data-cy="update-password-success-message">
          {{ successMessage }}
        </app-message>
      </div>
      <form
        class="col-12"
        [formGroup]="changePasswordForm"
        (ngSubmit)="onSubmitChangePassword()"
        data-cy="update-password-form"
      >
        <app-form-field
          [control]="asFormControl(changePasswordForm.get('currentPassword'))"
          name="currentPassword"
          label="Current Password"
          type="input"
          inputType="password"
        ></app-form-field>
        <app-form-field
          [control]="asFormControl(changePasswordForm.get('newPassword'))"
          name="newPassword"
          label="New Password"
          type="input"
          inputType="password"
        ></app-form-field>
        <app-form-field
          [control]="asFormControl(changePasswordForm.get('repeatPassword'))"
          [showNotMatchError]="true"
          name="repeatPassword"
          label="Confirm New Password"
          type="input"
          inputType="password"
        ></app-form-field>
        <app-password-checker passwordFieldName="newPassword"></app-password-checker>
        <!-- TODO Reflect loading state -->
        <app-form-footer
          [submitLabel]="(updatePasswordState$ | async)?.isLoading ? 'Updating Password...' : 'Save'"
          [disabled]="(updatePasswordState$ | async)?.isLoading"
          [handleSubmit]="this.onSubmitChangePassword.bind(this)"
          [handleCancel]="this.onCancelChangePassword.bind(this)"
          [justifyLeft]="true"
        ></app-form-footer>
      </form>
    </div>
  </p-card>
</app-page>
